import React from 'react';

import { Link } from 'react-router-dom';

function ArchivedStandards() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Archived Standards and Prior Versions</h1>

        <div className="space-y-12">
          
          {/* SECTION 1: Introduction */}
          <section>
            <p className="text-gray-800 leading-relaxed mb-6">
              To ensure transparency and traceability, the AASC maintains a permanent record of all standards versions. This archive allows verification of compliance against the specific version of a standard that was active at the time of an operator's assessment.
            </p>
          </section>

          {/* SECTION 2: Current Standards */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide bg-green-50 p-2 border-l-4 border-green-600">Current Standards (AASC 2.0)</h2>
            <div className="bg-white border border-gray-200 shadow-sm overflow-hidden">
              <table className="w-full text-left text-sm">
                <thead className="bg-gray-100 text-[#102A43]">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Identifier</th>
                    <th className="px-4 py-3 font-semibold">Title</th>
                    <th className="px-4 py-3 font-semibold">Pub. Date</th>
                    <th className="px-4 py-3 font-semibold">Status</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="px-4 py-3 font-mono text-[#2F80ED]"><Link to="/standards/ai-abnd-1-0">AI-ABND-1.0</Link></td>
                    <td className="px-4 py-3">Accountability Boundaries</td>
                    <td className="px-4 py-3 text-gray-500">2026-03-01</td>
                    <td className="px-4 py-3 font-bold text-green-700">Active</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-mono text-[#2F80ED]"><Link to="/standards/ai-hitl-1-0">AI-HITL-1.0</Link></td>
                    <td className="px-4 py-3">Human Authority & Escalation</td>
                    <td className="px-4 py-3 text-gray-500">2026-02-01</td>
                    <td className="px-4 py-3 font-bold text-green-700">Active</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-mono text-[#2F80ED]"><Link to="/standards/ai-acct-1-0">AI-ACCT-1.0</Link></td>
                    <td className="px-4 py-3">Outcome Accountability Mapping</td>
                    <td className="px-4 py-3 text-gray-500">2026-02-01</td>
                    <td className="px-4 py-3 font-bold text-green-700">Active</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-mono text-[#2F80ED]"><Link to="/standards/ai-read-1-0">AI-READ-1.0</Link></td>
                    <td className="px-4 py-3">Readiness & Incident Response</td>
                    <td className="px-4 py-3 text-gray-500">2026-02-01</td>
                    <td className="px-4 py-3 font-bold text-green-700">Active</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-mono text-[#2F80ED]"><Link to="/standards/ai-perf-1-0">AI-PERF-1.0</Link></td>
                    <td className="px-4 py-3">Performance Monitoring</td>
                    <td className="px-4 py-3 text-gray-500">2026-02-01</td>
                    <td className="px-4 py-3 font-bold text-green-700">Active</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-mono text-[#2F80ED]"><Link to="/standards/ai-roi-1-0">AI-ROI-1.0</Link></td>
                    <td className="px-4 py-3">Responsibility Domain Mapping</td>
                    <td className="px-4 py-3 text-gray-500">2026-02-01</td>
                    <td className="px-4 py-3 font-bold text-green-700">Active</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-mono text-[#2F80ED]"><Link to="/standards/ai-disc-1-0">AI-DISC-1.0</Link></td>
                    <td className="px-4 py-3">Client Disclosure</td>
                    <td className="px-4 py-3 text-gray-500">2026-02-01</td>
                    <td className="px-4 py-3 font-bold text-green-700">Active</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* SECTION 3: Superseded Standards */}
          <section className="opacity-60">
            <h2 className="text-xl font-bold text-[#64748B] mb-4 uppercase tracking-wide border-l-4 border-[#E2E8F0] pl-2">Superseded Standards</h2>
            <div className="bg-[#F9FAFB] border border-gray-200 p-6 text-center text-gray-500 italic">
              No superseded standards available.
            </div>
          </section>

          {/* SECTION 4: Withdrawn Standards */}
          <section className="opacity-60">
            <h2 className="text-xl font-bold text-[#64748B] mb-4 uppercase tracking-wide border-l-4 border-red-200 pl-2">Withdrawn Standards</h2>
            <div className="bg-[#F9FAFB] border border-gray-200 p-6 text-center text-gray-500 italic">
              No withdrawn standards.
            </div>
          </section>

        </div>
      </div>
    </>
  );
}

export default ArchivedStandards;